import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import './reviewChartBar.scss';

export default function ReviewChartBar({ rating, percentRating, reviewCount }) {
	return (
		<div className="review-chart-bar">
			<Text className="rating">
				{rating} star
			</Text>
			<div className="bar-container">
				<div className="bar" style={{ width: `${percentRating}%` }} />
			</div>
			<Text className="review-count">
				{reviewCount}
			</Text>
		</div>
	);
}

ReviewChartBar.propTypes = {
	/** What rating this is - i.e. 5 star, 4 star, etc */
	rating: PropTypes.number.isRequired,
	/** Percentage to show the bar at */
	percentRating: PropTypes.number.isRequired,
	/** How many reviews there are for the rating */
	reviewCount: PropTypes.number.isRequired
};
